import type { Attachment } from "../../types/attachment";
import { AttachmentRow } from "./AttachmentRow";

interface AttachmentsListProps {
  attachments: Attachment[];
}

export const AttachmentsList = ({ attachments }: AttachmentsListProps) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1">
      {attachments.map((attachment: Attachment) => (
        <AttachmentRow
          key={attachment.id}
          url={attachment.url}
          filename={attachment.filename}
        />
      ))}
    </div>
  );
};
